import { getRouteApi, useNavigate } from '@tanstack/react-router';
import * as React from 'react';

import {
  CguRegistreScreen,
  type CguRegistreNavTarget,
  type CguRegistreTab,
} from '@/routes/admin/cgu/cgu-registre-screen';

// =============================================================================
// cgu-registre-route.tsx — Adaptateur routeur du registre CGU (A-CGU ÉTAPE 2).
// =============================================================================
// Route `/admin/cgu` (monde ADMIN authentifié — chrome monté par le routage, SEC-NAV préservé).
// L'ONGLET actif (`tab`) et la VERSION sélectionnée (`version`) vivent dans les SEARCH PARAMS
// d'URL (RULE_REF_006 : pas de localStorage) — deep-linkables, compatibles bouton retour.
// Le composant de présentation (CguRegistreScreen) reste testable hors routeur (contrôlé).

const routeApi = getRouteApi('/admin/cgu');

/** Onglet par défaut (registre des versions). */
const DEFAULT_TAB: CguRegistreTab = 'versions';

export function CguRegistreRoute(): React.JSX.Element {
  const navigate = useNavigate();
  const search = routeApi.useSearch();

  const activeTab = search.tab ?? DEFAULT_TAB;
  const selectedVersionId = search.version;

  // Navigation ATOMIQUE : onglet + version dans UNE seule écriture de search (RULE_REF_006).
  // Un seul navigate() élimine le clobber des deux appels séparés (le 2e écrasait le 1er depuis une
  // closure périmée → `version` perdu à l'« Ouvrir »). On sérialise UNIQUEMENT le non-défaut (URL
  // propre, exactOptionalPropertyTypes) : « versions » (onglet défaut) et version absente omis.
  const onNavigate = React.useCallback(
    ({ tab, version }: CguRegistreNavTarget): void => {
      void navigate({
        to: '/admin/cgu',
        search: {
          ...(tab !== DEFAULT_TAB ? { tab } : {}),
          ...(version !== undefined && version.length > 0 ? { version } : {}),
        },
      });
    },
    [navigate],
  );

  return (
    <CguRegistreScreen
      activeTab={activeTab}
      selectedVersionId={selectedVersionId}
      onNavigate={onNavigate}
    />
  );
}
